(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pricing', {
            parent: 'entity',
            url: '/pricing?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.pricing.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pricing/pricings.html',
                    controller: 'PricingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pricing');
                    $translatePartialLoader.addPart('onOff');
                    $translatePartialLoader.addPart('priceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pricing-detail', {
            parent: 'pricing',
            url: '/pricing/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.pricing.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pricing/pricing-detail.html',
                    controller: 'PricingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pricing');
                    $translatePartialLoader.addPart('onOff');
                    $translatePartialLoader.addPart('priceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pricing', function($stateParams, Pricing) {
                    return Pricing.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pricing',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pricing-detail.edit', {
            parent: 'pricing-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pricing/pricing-dialog.html',
                    controller: 'PricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pricing', function(Pricing) {
                            return Pricing.get({id : $stateParams.id}).$promise;
                        }],
                        contractPage: function() {
                            return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pricing.new', {
            parent: 'pricing',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pricing/pricing-dialog.html',
                    controller: 'PricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                price: null,
                                icPrice: null,
                                onOff: null,
                                month: null,
                                year: null,
                                priceType: null,
                                fixed: null,
                                unfixed: null,
                                id: null
                            };
                        },
                        contractPage: function() {
                            return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('pricing', null, {reload: 'pricing'});
                }, function() {
                    $state.go('pricing');
                });
            }]
        })
        .state('pricing.edit', {
            parent: 'pricing',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pricing/pricing-dialog.html',
                    controller: 'PricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pricing', function(Pricing) {
                            return Pricing.get({id : $stateParams.id}).$promise;
                        }],
                        contractPage: function() {
                            return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('pricing', null, { reload: 'pricing' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pricing.delete', {
            parent: 'pricing',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pricing/pricing-delete-dialog.html',
                    controller: 'PricingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pricing', function(Pricing) {
                            return Pricing.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pricing', null, { reload: 'pricing' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
